/// \file aemp.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const AempList = lazy(() => import('../views/aemp/list/view'));

async function aempDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/aemp/list/loader')).default;
  return actualLoader(args);
}

export async function aempAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/aemp/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="aemp"
    handle={{
      text: 'AEMP'
      }}
  >
    <Route 
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <AempList />
        </Suspense>
      }     
      loader={aempDataLoader}
      action={aempAction}
      />
  </Route>
);

export default routes;